// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609231547/js/" + chunkId + "." + {"44":"b0b28e91","225":"82b32d26","481":"e1635112","486":"6eb3b71a","770":"d41ddedd"}[chunkId] + ".0.7274798699103702.chunk.js";
};